import type { LoginAsStats } from './PlatformValueTab';
import { Card, CardContent } from '../../components/ui/card';

const BY_LABELS: Record<string, string> = {
  valuechain: 'Valuechain staff',
  customer: 'Customer admins',
};

const ROLE_LABELS: Record<string, string> = {
  customer_admin: 'customer admin',
  customer_user: 'customer user',
  supplier_admin: 'supplier admin',
  supplier_user: 'supplier user',
};

interface LoginAsCardProps {
  login: LoginAsStats;
}

/**
 * Login-As over the last 30 days: how many sessions, who started them
 * (Valuechain staff or customer admins) and which roles they logged in as.
 */
export default function LoginAsCard({ login }: LoginAsCardProps) {
  return (
    <Card className="border-slate-200 mt-3">
      <CardContent className="pt-4">
        <p className="text-sm font-medium text-slate-700">Login-As, last 30 days</p>
        <p className="text-xs text-muted-foreground mb-2">
          {login.sessions_started.toLocaleString()} sessions started by {login.impersonators} people,
          logging in as {login.people_impersonated} different users · {login.hours}h of activity.
        </p>
        {login.by_pair.length === 0 ? (
          <p className="text-xs text-muted-foreground">No Login-As sessions in the last 30 days.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-xs text-slate-500 border-b border-slate-200">
                  <th className="px-3 py-2">Who</th>
                  <th className="px-3 py-2">Logged in as</th>
                  <th className="px-3 py-2 text-right">Sessions</th>
                </tr>
              </thead>
              <tbody>
                {login.by_pair.map((p) => (
                  <tr key={`${p.by}-${p.as_role}`} className="border-b border-slate-100">
                    <td className="px-3 py-1.5 font-medium">{BY_LABELS[p.by] ?? p.by}</td>
                    <td className="px-3 py-1.5">{ROLE_LABELS[p.as_role] ?? p.as_role}</td>
                    <td className="px-3 py-1.5 text-right tabular-nums">{p.sessions.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
